import { ProgressSpinner } from "primereact/progressspinner";
import React from "react";
import styled from "styled-components";

export interface SpFormSpinnerProps {
  delay?: number;
  style?: React.CSSProperties;
}
export const SpFormSpinner = (props: SpFormSpinnerProps) => {
  // dont show spinner until some time has passed
  // reduces chance that the spinner just flashes
  const { delay = 333, style } = props;

  const [waiting, setWaiting] = React.useState(delay >= 0);

  React.useEffect(() => {
    const timeout = setTimeout(() => {
      setWaiting(false);
    }, delay);

    return () => {
      clearTimeout(timeout);
    };
  }, []);

  return (
    <StyledSpFormSpinner style={style}>
      {/* {!waiting && !isAppTypeIframe() && <SillyLoader />} */}
      {!waiting && <ProgressSpinner />}
    </StyledSpFormSpinner>
  );
};

const StyledSpFormSpinner = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 300px;
  min-width: 300px;
  height: 100%;
  margin: auto;
`;
